import { Box, Button, ButtonProps } from '@mui/material';
import React from 'react';
import { Tooltip } from '../../../Tooltip';

export type InvoiceLineItemAddLineItemButtonProps = ButtonProps;

export const InvoiceLineItemAddLineItemButton: React.FC<
InvoiceLineItemAddLineItemButtonProps
> = ( { children, ...props } ) =>
	props.disabled ? (
		<Tooltip
			// it's a long tooltip so we need to anchor it to the left
			anchorOrigin={ {
				vertical: 'bottom',
				horizontal: 'left',
			} }
			transformOrigin={ {
				// When portal-ing is disabled, we have to use PX because the tooltip has no height
				vertical: -30,
				horizontal: 'left',
			} }
			target={
				<Box>
					<Button { ...props }>{ children }</Button>
				</Box>
			}
			disablePortal
		>
			You have reached the maximum number of line items. Please remove some line
			items before adding a new one.
		</Tooltip>
	) : (
		<Button { ...props }>{ children }</Button>
	);
